import React, { useEffect, useState, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import ReactSelect from '../Common/ReactSelect';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { ADD_USER_REGISTER } from '../Common/API';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getAllCountry, getCity } from '../../Redux/CommonSlice';
import axios from 'axios';
import { handleUserRole } from '../../Redux/UserSlice';
import toast from 'react-hot-toast';

const labelClass = 'mb-1.5 block text-xs font-bold tracking-wide text-slate-600';
const inputClass =
    'w-full rounded-lg border border-slate-200 bg-white p-2.5 text-sm text-slate-800 outline-none transition-all placeholder:text-slate-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100';
const errorClass = 'mt-1 block text-xs font-semibold text-red-500';

export default function AddEditUsers({ setUserModal, fetchUserData, UserData, toggleModal }) {
    const hiddenFileInput = useRef(null);
    const store = useSelector((state) => state.root.common);
    const UserRole = useSelector((state) => state.root.UserRole);
    const { token, user } = useSelector((state) => state.root.auth);

    const dispatch = useDispatch();
    const { control, handleSubmit, register, setValue, formState: { errors,isSubmitting  }, reset, clearErrors } = useForm({
        defaultValues: {
            username: UserData?.userName || '',
            email: UserData?.email || '',
            mobileNumber: UserData?.phoneNumber || '',
            Password: '',
            Street: UserData?.street || '',
            ZipCode: UserData?.zipCode || '',
            status: UserData?.status || false,
            city: UserData?.cityName
        }
    });
    const [showPassword, setShowPassword] = useState(false);
    const [file, setfile] = useState(null);
    const [selectedValue, setSelectedValue] = useState({ Country: null, City: null, Role: null });

    const isEdit = Boolean(UserData?.userID);
    const profilePreview = file
        ? URL.createObjectURL(file)
        : UserData?.profilePic
            ? `${UserData?.profilePic}`
            : null;

    useEffect(() => {
        dispatch(handleUserRole({ mode: "SelectList" })).then(() => toast.remove());
    }, [dispatch]);

    useEffect(() => {
        const id = selectedValue?.Country?.value || null;
        if (id) dispatch(getCity(id));
    }, [dispatch, selectedValue?.Country?.value]);

    useEffect(() => {
        dispatch(getAllCountry({}));
    }, [dispatch])

    useEffect(() => {
        toast.loading('loading ...');
        if (UserData) {
            toast.remove();
            reset({
                username: UserData?.userName || '',
                email: UserData?.email || '',
                mobileNumber: UserData?.phoneNumber || '',
                Password: '',
                Street: UserData?.street || '',
                ZipCode: UserData?.zipCode || '',
                status: UserData?.status,
                city: UserData?.cityName,
                country: UserData?.countryName,
                role: UserData?.userRoleName,
            });
            if (UserData?.countryID || UserData?.cityID || UserData?.userRoleID) {
                setSelectedValue({
                    Country: { label: UserData?.countryName, value: UserData?.countryID } || null,
                    City: { label: UserData?.cityName, value: UserData?.cityID } || null,
                    Role: { label: UserData?.userRoleName, value: UserData?.userRoleID } || null,
                });
            }
        }
    }, [UserData, reset]);

    const handleClose = () => {
        toggleModal();
        setSelectedValue({});
    };

    const onSubmit = async (data) => {
        const systemTimeZone = new Date().toLocaleDateString(undefined, { day: "2-digit", timeZoneName: "long" }).substring(4);
        const formdata = new FormData();
        formdata.append("UserID", UserData?.userID ? UserData?.userID : 0);
        formdata.append("UserName", data?.username);
        formdata.append("Password", data?.Password);
        formdata.append("Email", data?.email);
        formdata.append("PhoneNumber", data?.mobileNumber);
        formdata.append("SystemTimeZone", systemTimeZone);
        formdata.append("UserRoleID", selectedValue?.Role?.value || 0);
        formdata.append("CityID", selectedValue?.City?.value || 0);
        formdata.append("CountryID", selectedValue?.Country?.value || 0);
        formdata.append("Street", data?.Street);
        formdata.append("ZipCode", data?.ZipCode);
        formdata.append("Operation", 'Save');
        formdata.append("status", data?.status);
        formdata.append("File", file);
        formdata.append("ParentID", user?.userID);
        formdata.append("profilePic", UserData?.profilePic ? UserData?.profilePic : '');

        try {
            const { data: response } = await axios.post(ADD_USER_REGISTER, formdata, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response?.status) {
                fetchUserData();
                toast.success(response?.message);
                setUserModal(false);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.log('error :>> ', error);
        }
    };

    return (
        <div
            id="default-modal"
            tabIndex="-1"
            aria-hidden="true"
            className="fixed inset-0 z-[9999] flex min-h-screen w-full items-center justify-center bg-slate-900/60 p-4 backdrop-blur-sm"
        >
            <div className="w-full max-w-2xl max-h-[calc(100vh-32px)]">
                <div className="relative flex max-h-[calc(100vh-32px)] flex-col overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-2xl">
                    <div className="flex shrink-0 items-center justify-between border-b border-slate-100 bg-slate-50/50 px-5 py-4">
                        <div>
                            <h3 className="text-lg font-bold text-slate-800">
                                {isEdit ? 'Update User' : 'Add User'}
                            </h3>
                            <p className="mt-0.5 text-xs text-slate-500">
                                {isEdit ? 'Update user details and permissions' : 'Create a new user account'}
                            </p>
                        </div>
                        <button
                            type="button"
                            onClick={handleClose}
                            className="rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
                        >
                            <AiOutlineCloseCircle className="text-2xl" />
                        </button>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)} className="flex min-h-0 flex-1 flex-col">
                        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5 vertical-scroll-inner">
                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                                <div>
                                    <label htmlFor="username" className={labelClass}>Username</label>
                                    <Controller
                                        name="username"
                                        control={control}
                                        defaultValue=""
                                        rules={{ required: 'Username is Required' }}
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                type="text"
                                                id="username"
                                                placeholder="Enter username"
                                                className={`${inputClass} capitalize`}
                                            />
                                        )}
                                    />
                                    {errors.username && <span className={errorClass}>{errors.username.message}</span>}
                                </div>

                                <div>
                                    <label htmlFor="userRole" className={labelClass}>User Role</label>
                                    <Controller
                                        name="role"
                                        control={control}
                                        defaultValue=""
                                        rules={{ required: 'User Role is Required' }}
                                        render={({ field }) => (
                                            <ReactSelect
                                                {...field}
                                                options={UserRole?.UserRole?.data?.length > 0
                                                    ? UserRole?.UserRole?.data?.map(item => ({
                                                        value: item?.usersRoleID,
                                                        label: item?.userRole,
                                                    }))
                                                    : [{ value: "", label: "Not Found" }]}
                                                handleSelectChange={(option) => {
                                                    setSelectedValue(prev => ({ ...prev, Role: option }));
                                                    setValue('role', option);
                                                    clearErrors('role');
                                                }}
                                                selectedValue={selectedValue?.Role}
                                            />
                                        )}
                                    />
                                    {!(selectedValue?.Role?.label?.length > 0) && errors.role && (
                                        <span className={errorClass}>{errors.role.message}</span>
                                    )}
                                </div>

                                {!isEdit && (
                                    <>
                                        <div>
                                            <label htmlFor="email" className={labelClass}>Email</label>
                                            <Controller
                                                name="email"
                                                control={control}
                                                defaultValue=""
                                                rules={{
                                                    required: 'Email is Required',
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                        message: 'Email is invalid',
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        id="email"
                                                        placeholder="Enter email"
                                                        className={inputClass}
                                                    />
                                                )}
                                            />
                                            {errors.email && <span className={errorClass}>{errors.email.message}</span>}
                                        </div>

                                        <div>
                                            <label htmlFor="Password" className={labelClass}>Password</label>
                                            <div className="relative">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    id="Password"
                                                    placeholder="Enter password"
                                                    className={`${inputClass} pr-10`}
                                                    {...register("Password", {
                                                        required: "Password is Required",
                                                        pattern: {
                                                            value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                                                            message: "Must contain 8+ chars with upper, lower, number & special character",
                                                        },
                                                    })}
                                                />
                                                <button
                                                    type="button"
                                                    className="absolute inset-y-0 right-3 flex items-center text-slate-400 hover:text-slate-600"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                >
                                                    {showPassword ? <BsFillEyeFill size={15} /> : <BsFillEyeSlashFill size={15} />}
                                                </button>
                                            </div>
                                            {errors.Password && <p className={errorClass}>{errors.Password.message}</p>}
                                        </div>
                                    </>
                                )}

                                <div>
                                    <label htmlFor="country" className={labelClass}>Country</label>
                                    <Controller
                                        name="country"
                                        control={control}
                                        defaultValue=""
                                        rules={{ required: 'Country is Required' }}
                                        render={({ field }) => (
                                            <ReactSelect
                                                {...field}
                                                options={store?.Country?.map(item => ({
                                                    value: item.countryID,
                                                    label: item.countryName,
                                                })) || [{ value: "", label: "Not Found" }]}
                                                handleSelectChange={(option) => {
                                                    setSelectedValue(prev => ({ ...prev, Country: option, City: null }));
                                                    setValue('country', option);
                                                    clearErrors('country');
                                                }}
                                                selectedValue={selectedValue?.Country}
                                            />
                                        )}
                                    />
                                    {!(selectedValue?.Country?.label?.length > 0) && errors.country && (
                                        <span className={errorClass}>{errors.country.message}</span>
                                    )}
                                </div>

                                <div>
                                    <label htmlFor="city" className={labelClass}>City</label>
                                    <Controller
                                        name="city"
                                        control={control}
                                        rules={{ required: 'City is Required' }}
                                        render={({ field }) => (
                                            <ReactSelect
                                                {...field}
                                                options={store?.City?.map(item => ({
                                                    value: item.cityID,
                                                    label: item.cityName,
                                                })) || [{ value: "", label: "Not Found" }]}
                                                handleSelectChange={(option) => {
                                                    setSelectedValue(prev => ({ ...prev, City: option }));
                                                    setValue('city', option);
                                                    clearErrors('city');
                                                }}
                                                selectedValue={selectedValue?.City}
                                            />
                                        )}
                                    />
                                    {errors.city && <span className={errorClass}>{errors.city.message}</span>}
                                </div>

                                <div>
                                    <label htmlFor="Street" className={labelClass}>Street</label>
                                    <Controller
                                        name="Street"
                                        control={control}
                                        defaultValue=""
                                        rules={{ required: 'Street is Required' }}
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                type="text"
                                                id="Street"
                                                placeholder="Enter street"
                                                className={`${inputClass} capitalize`}
                                            />
                                        )}
                                    />
                                    {errors?.Street && <span className={errorClass}>{errors?.Street?.message}</span>}
                                </div>

                                <div>
                                    <label htmlFor="ZipCode" className={labelClass}>Zip Code</label>
                                    <Controller
                                        name="ZipCode"
                                        control={control}
                                        defaultValue=""
                                        rules={{ required: 'ZipCode is required' }}
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                type="number"
                                                min="0"
                                                id="ZipCode"
                                                placeholder="Enter zip code"
                                                className={inputClass}
                                            />
                                        )}
                                    />
                                    {errors?.ZipCode && <span className={errorClass}>{errors?.ZipCode?.message}</span>}
                                </div>
                            </div>

                            <div className="mt-5 flex flex-wrap items-center justify-between gap-4 rounded-xl border border-slate-100 bg-slate-50/60 px-4 py-3">
                                <div className="flex items-center gap-3">
                                    <div className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-white text-sm font-bold text-indigo-600">
                                        {profilePreview ? (
                                            <img src={profilePreview} alt="Profile" className="h-full w-full object-cover" />
                                        ) : (
                                            <span>?</span>
                                        )}
                                    </div>
                                    <div>
                                        <p className="text-xs font-semibold text-slate-700">Profile Photo</p>
                                        <p className="text-[11px] text-slate-400">Upload a profile image</p>
                                    </div>
                                    <button
                                        type="button"
                                        className="rounded-lg bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-indigo-700"
                                        onClick={() => hiddenFileInput.current.click()}
                                    >
                                        Choose file
                                    </button>
                                    <input
                                        type="file"
                                        className="hidden"
                                        ref={hiddenFileInput}
                                        onChange={(e) => setfile(e.target.files[0])}
                                        accept="image/*"
                                    />
                                </div>

                                <label htmlFor="status" className="flex cursor-pointer items-center gap-2.5">
                                    <span className="text-sm font-medium text-slate-600">Is Active</span>
                                    <input
                                        id="status"
                                        type="checkbox"
                                        className="h-4 w-4 cursor-pointer rounded border-slate-300 text-indigo-600 focus:ring-2 focus:ring-indigo-100"
                                        {...register('status')}
                                    />
                                </label>
                            </div>
                        </div>

                        <div className="flex shrink-0 items-center justify-between border-t border-slate-100 bg-slate-50/50 px-5 py-4">
                            <button
                                type="button"
                                className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 transition-colors hover:bg-slate-100"
                                onClick={handleClose}
                                disabled={isSubmitting}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="rounded-lg bg-indigo-600 px-5 py-2 text-sm font-semibold text-white shadow-md transition-all hover:bg-indigo-700 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Saving...' : (isEdit ? 'Update' : 'Save')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
